import React, { useEffect, useState} from 'react';
import BoxBannersSmall from 'components/BoxBannersSmall';
import PropTypes from 'prop-types';
import TagManagerService from 'services/TagManager';
import CMSFactory from "factories/CMS";
import style from './style.scss'; //NOSONAR

let box = [];
let tagBox = [];
let dateServer = '';
let count = 0;


const HighLights = (props) => {
    const [highLights , setHighLigths] = useState([]);
    let boxes = [];

    useEffect(() => {
        count = 0;
        dateServer = props.date ? props.date : '';
        box = props.data ? props.data.high_lights : [];

        box.map((banner) => {

            if(count > 3) return false;
            let serverDate = dateServer;
            let startDate = banner.start_date ? CMSFactory.milliseconds(banner.start_date) : '';
            let endDate = banner.end_date ? CMSFactory.milliseconds(banner.end_date) : '';
            if (startDate && (startDate >= serverDate)) return false;
            if(endDate && (endDate <= serverDate)) return false;
            if (banner.active !== true) return false;
            
            banner.typePromotion = 'Recomendados';
            
            tagBox.push({
                id: banner.image ? banner.image.split('/').pop() : '',
                name: banner.title,
                creative: banner.typePromotion,
                position: 'slot' + (count+1)
            });
            count++;
            
            boxes.push(banner);
            
        }).filter(Boolean);

        setHighLigths(boxes);

            
        TagManagerService.promotionsImpressions(tagBox);

    }, [props.data]);

    return (
        <div className='recommended-container-wrapper'>
            <div className='recommended-title-container'>
                <span className='recommended-title'>Recomendados</span>
            </div>
            <div className='banners-recommended-container'>
                {highLights.map((banner, i) => {
                    return <BoxBannersSmall banner={banner} key={i} position={('slot' + (i+1))} />
                })}
            </div>
        </div>
    )
}

HighLights.propTypes = {
    data: PropTypes.object,
    date: PropTypes.number
}

export default HighLights;
